import { createContext } from 'react';

export const ConfigMessageContext = createContext({
  isQuickCancel: false,
  setIsQuickCancel: () => {},
  bypassApigee: null,
  isRegistration: false,
  setIsRegistration: () => {},
});
